// @flow

import React from 'react';
import { LanguageList, LanguageListItem } from './atoms';
import type { ActiveLanguage } from '../../store/activeLanguage';
import type { Languages } from '../../types/settings';

type Props = {|
  activeLanguage: ActiveLanguage,
  languages: Languages,
  onSelectLanguage: (language: string) => void,
|};

const LanguageSelector = ({
  activeLanguage,
  languages,
  onSelectLanguage,
}: Props) => (
  <LanguageList>
    {languages.map(({ code, label }) => (
      <LanguageListItem
        key={code}
        code={code}
        label={label}
        activeLanguage={activeLanguage}
        onSelectLanguage={onSelectLanguage}
      />
    ))}
  </LanguageList>
);

export default LanguageSelector;
